import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { Loading } from '@puppet/react-components';
import ViewPipeline from '@codeDelivery/components/ViewPipeline';
import { BreadcrumbsType } from '@components/Breadcrumbs/Breadcrumbs';
import Cd4peError from '@components/Cd4peError';
import useWorkspaceDomain from '@hooks/useWorkspaceDomain';
import useWorkspaceName from '@hooks/useWorkspaceName';
import { useGetControlRepoV1 } from '@services/cd4pe/controlRepos';
import { LINKS } from 'src/routes';

const ViewControlRepo = () => {
  const { t } = useTranslation('codeDelivery');
  const workspaceName = useWorkspaceName();
  const workspaceId = useWorkspaceDomain();
  const { name = '' } = useParams();

  const { data, isLoading, error } = useGetControlRepoV1({
    workspaceId,
    controlRepoName: name,
  });

  const breadcrumbs: BreadcrumbsType = [
    {
      displayName: workspaceName,
    },
    {
      displayName: t('viewControlRepo.breadcrumb.controlRepos'),
      linkDestination: LINKS.codeDelivery.listRepositories({
        path: { workspace: workspaceName },
      }),
    },
    { displayName: data?.name ?? '' },
  ];

  if (isLoading) {
    return <Loading />;
  }

  if (error) {
    return <Cd4peError error={error} />;
  }

  return (
    <ViewPipeline
      breadcrumbs={breadcrumbs}
      name={name}
      codeProject={data!}
      projectType="CONTROL_REPO"
    />
  );
};

export default ViewControlRepo;
